import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'
import { InvoiceConfigRow } from '../types'

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

type EditInvoiceConfigWorkflow = {
  open: (invoiceConfig: InvoiceConfigRow) => void
  close: () => void
  isOpen: boolean
  invoiceConfig: InvoiceConfigRow | null
}

export type InvoiceConfigWorkflowsContextState = {
  createInvoiceConfigFlow: Workflow
  editInvoiceConfigFlow: EditInvoiceConfigWorkflow
}

const [InvoiceConfigWorkflowsContext, useInvoiceConfigWorkflowsContextValue] =
  createContext<InvoiceConfigWorkflowsContextState>({
    name: 'InvoiceConfigWorkflowsContext',
  })

export const InvoiceConfigWorkflowsProvider = ({
  children,
}: PropsWithChildren) => {
  const [isCreateInvoiceConfigFlowOpen, setIsCreateInvoiceConfigFlowOpen] =
    useState(false)
  const [isEditInvoiceConfigFlowOpen, setIsEditInvoiceConfigFlowOpen] =
    useState(false)
  const [editInvoiceConfig, setEditInvoiceConfig] =
    useState<InvoiceConfigRow | null>(null)

  const value: InvoiceConfigWorkflowsContextState = {
    createInvoiceConfigFlow: {
      open: () => setIsCreateInvoiceConfigFlowOpen(true),
      close: () => setIsCreateInvoiceConfigFlowOpen(false),
      isOpen: isCreateInvoiceConfigFlowOpen,
    },
    editInvoiceConfigFlow: {
      open: (invoiceConfig: InvoiceConfigRow) => {
        setEditInvoiceConfig(invoiceConfig)
        setIsEditInvoiceConfigFlowOpen(true)
      },
      // Keep the selected invoice config so the modal close animation isn't cut short.
      close: () => setIsEditInvoiceConfigFlowOpen(false),
      isOpen: isEditInvoiceConfigFlowOpen,
      invoiceConfig: editInvoiceConfig,
    },
  }

  return (
    <InvoiceConfigWorkflowsContext.Provider value={value}>
      {children}
    </InvoiceConfigWorkflowsContext.Provider>
  )
}

export { useInvoiceConfigWorkflowsContextValue }
